import React, { useEffect, useState } from "react";
import { useLocale } from "@davi-ai/retorik-framework";
import {
  configurationChangeAction,
  printerSetAction,
} from "../../redux/Actions";
import { useConfiguration } from "../../redux/Hooks";
import { useDispatchKiosk } from "../../redux/Hooks/Kiosk/useDispatchKiosk";
import type { Printer } from "../../model/Printer";
import translation from "../../translations/menuItems.json";
import commonTranslation from "../../translations/common.json";
import Button from "../Common/Button";
import OnOffButton from "./OnOffButtons";
import usePrinter from "../../redux/Hooks/Kiosk/usePrinter";
import tempConfigurationChangeAction from "../../redux/Actions/Kiosk/tempConfigurationChangeAction";

const PrintingOptions = () => {
  const locale: string = useLocale();
  const dispatch = useDispatchKiosk();
  const configuration = useConfiguration();
  const [currentPrintingAllowed, setCurrentPrintingAllowed] = useState<boolean>(
    !!configuration.enableDocumentPrinting
  );
  const printer = usePrinter();
  const [currentPrinter, setCurrentPrinter] = useState<string | null>(printer);
  const [printers, setPrinters] = useState<Array<Printer>>([]);

  const togglePrintingAllowed = (): void => {
    setCurrentPrintingAllowed((current) => !current);
  };

  const save = () => {
    if (currentPrintingAllowed !== !!configuration.enableDocumentPrinting) {
      dispatch(
        configurationChangeAction({
          ...configuration,
          enableDocumentPrinting: currentPrintingAllowed,
        })
      );
      dispatch(tempConfigurationChangeAction({ enableDocumentPrinting: currentPrintingAllowed }));
    }
    dispatch(printerSetAction(currentPrinter));
  };

  const getPrinters = async (): Promise<void> => {
    // if (window.electronAPI) {
    //   const retrievedPrinters: Array<Printer> =
    //     await window.electronAPI.getPrinters();
    //   setPrinters(retrievedPrinters);
    // }
  };

  useEffect(() => {
    getPrinters();
  }, []);

  const handleClick = (name: string): void => {
    setCurrentPrinter(name);
  };

  return (
    <div className="w-full h-9/10 flex flex-col justify-between">
      <div className="w-full flex flex-col gap-4 mt-6 px-1">
        <div className="flex flex-row justify-between items-center">
          {translation[locale]?.printers.title ||
            translation["fr-FR"].printers.title}
          <OnOffButton
            toggle={currentPrintingAllowed}
            returnFunction={togglePrintingAllowed}
          />
        </div>

        {currentPrintingAllowed && (
          <div className="flex flex-col items-start gap-2">
            {translation[locale]?.printers.subtitle ||
              translation["fr-FR"].printers.subtitle}
            {printers.map((printer: Printer, key: number) => (
              <div
                key={key}
                className={`w-full px-4 py-1 border hover:cursor-pointer ${
                  printer.name === currentPrinter
                    ? "border-white cursor-default"
                    : "border-black/50"
                }`}
                onClick={() => handleClick(printer.name)}
              >
                {`${printer.displayName}${printer.isDefault ? " (default)" : ""}`}
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="mb-2 mt-1 flex justify-center">
        <Button
          label={
            commonTranslation[locale]?.save || commonTranslation["fr-FR"].save
          }
          onClick={save}
        >
          {commonTranslation[locale]?.save || commonTranslation["fr-FR"].save}
        </Button>
      </div>
    </div>
  );
};

export default PrintingOptions;
